import { useContext } from 'react'

import { RequestWizardDraft } from '../../../../context'

export function useRequestWizardDraft() {
  return useContext(RequestWizardDraft)
}
